import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './Typefaces.css';

const sizes = [
    180, 160, 140, 120, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 8
];

const mobileSizes = [
    6, 8, 10, 20, 30, 40, 50, 60, 70, 80
];

function Typefaces(props) {
    const [font, setFont] = useState(props.fonts[0].title);
    const [swipersIndex, setSwipersIndex] = useState(7);
    const [swipers, setSwipers] = useState(null);
    const [swipers2, setSwipers2] = useState(null);
    const touchStartRef = useRef(null);

    // Swipe detection handlers
    const handleTouchStart = useCallback((e) => {
        const touch = e.changedTouches[0];
        touchStartRef.current = touch.pageY;
    }, []);

    const handleTouchEnd = useCallback((e) => {
        if (!touchStartRef.current) return;

        const touch = e.changedTouches[0];
        const distY = touch.pageY - touchStartRef.current;
        const threshold = 50; // Minimum distance to be considered a swipe

        if (Math.abs(distY) >= threshold) {
            if (distY > 0) {
                if (swipers2) {
                    swipers2.slidePrev();
                }
            } else {
                if (swipers2) {
                    swipers2.slideNext();
                }
            }
        }

        touchStartRef.current = null;
    }, [swipers2]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowUp') {
                if (swipers2) {
                    swipers2.slidePrev();
                }
            }
            if (e.key === 'ArrowDown') {
                if (swipers2) {
                    swipers2.slideNext();
                }
            }
            if (e.key === 'ArrowLeft') {
                if (swipers) {
                    swipers.slidePrev();
                }
            }
            if (e.key === 'ArrowRight') {
                if (swipers) {
                    swipers.slideNext();
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        // Cleanup function to remove the classes
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [props.typefaceBackground, swipers, swipers2]);

    const switchFontSize = () => {
        if (props.isDown) {
            if (swipers) {
                swipers.slidePrev();
                return;
            }
        }

        if (props.isUp) {
            if (swipers) {
                swipers.slideNext();
                return;
            }
        }
    }

    const switchFont = () => {
        if (props.isDown) {
            if (swipers2) {
                swipers2.slidePrev();
                return;
            }
        }

        if (props.isUp) {
            if (swipers2) {
                swipers2.slideNext();
                return;
            }
        }
    }

    return (
        <React.Fragment>
            {props.mobile && (<div
                className='typeface-container-mobile'
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                <div className='flex justify-center'>
                    <div className='flex double-line-height navigation-mobile-vertical'>
                        <div className='mr-2'>
                            <div>
                                Title:
                            </div>
                        </div>
                        <Swiper
                            allowTouchMove={false}
                            slidesPerView={30}
                            loop={true}
                            onSwiper={setSwipers2}
                            direction='vertical'
                            initialSlide={0}
                            style={{ height: 'calc(100dvh - var(--mobile-header-height) - var(--mobile-header-height)' }}
                            touchRatio={1}
                            centeredSlides={false}
                            onSlideChange={(swipers) => {
                                props.setTypefaceSwiperIndex(swipers.realIndex % props.fonts.length);
                                setFont(props.fonts[swipers.realIndex % props.fonts.length].title);
                            }}
                        >
                            {[...props.fonts, ...props.fonts, ...props.fonts, ...props.fonts, ...props.fonts, ...props.fonts, ...props.fonts, ...props.fonts, ...props.fonts].map((font, index) => (
                                <SwiperSlide key={index}>
                                    <div className={`${props.typefaceSwiperIndex === index ? 'active' : ''}`}>
                                        <div>
                                            {font.title}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
                <div className='h-1/2 w-full left-0 flex top-1/2 -translate-y-1/2 flex-col justify-center absolute' style={{ backgroundColor: 'var(--current-background)', transition: 'background-color 0.5s ease, color 0.5s ease' }}>
                    {!props.showInformation && <textarea spellCheck="false" placeholder={`${font ? font : ''}, enter text...`}
                        style={{ fontFamily: font ? font : 'Suisse Intl Semibold', fontSize: mobileSizes[swipersIndex], lineHeight: (mobileSizes[swipersIndex] * 1) + 'px', backgroundColor: 'var(--current-background)', transition: 'background-color 0.5s ease, color 0.5s ease', color: 'var(--current-text)', margin: '0', width: '100%', textAlign: 'center' }} className='text-area-mobile pt-4'>
                    </textarea>}
                    <div className='flex navigation-mobile-horizontal pb-4' style={{ backgroundColor: 'var(--current-background)' }}>
                        <Swiper
                            allowTouchMove={true}
                            touchRatio={1}
                            onSwiper={setSwipers}
                            slidesPerView="9"
                            initialSlide={5}
                            centeredSlides={true}
                            onSlideChangeTransitionStart={(swipers) => {
                                setSwipersIndex(swipers.activeIndex);
                            }}
                        >
                            {mobileSizes.map((folderName, index) => (
                                <SwiperSlide key={index}>
                                    <div className={`${swipersIndex === index ? 'active' : ''} text-center`}>
                                        {folderName}
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
            )
            }
            {!props.mobile && (<div className='typeface-container'>
                <div onClick={switchFont} className="navigation" id='typefacesNavigation' onMouseMove={props.onMouseMove}
                    onMouseLeave={props.onMouseLeave}>
                    <div className='swiper-container double-line-height'>
                        <Swiper
                            className='swiper'
                            allowTouchMove={true}
                            slidesPerView={'auto'}
                            onSwiper={setSwipers2}
                            direction='vertical'
                            style={{ height: '100%' }}
                            initialSlide={props.typefaceSwiperIndex}
                            autoHeight={true}
                            centeredSlides={true}
                            onSlideChange={(swipers) => {
                                props.setTypefaceSwiperIndex(swipers.activeIndex);
                                setFont(props.fonts[swipers.activeIndex].title);
                            }}
                        >
                            {props.fonts.map((font, index) => (
                                <SwiperSlide className='swiper-slide-s' key={index}>
                                    <div className={`navigation-entry ${props.typefaceSwiperIndex === index ? 'active' : ''}`}>
                                        <div>
                                            {font.title}
                                        </div>
                                        <div>
                                            {font.glyphs}
                                        </div>
                                        <div>
                                            {font.type}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
                {!props.showInformation && <textarea spellCheck="false" placeholder={`${font ? font : ''}, enter text here...`}
                    style={{ fontFamily: font ? font : 'Suisse Intl Semibold', fontSize: sizes[swipersIndex], lineHeight: (sizes[swipersIndex] * 1) + 'px', backgroundColor: 'var(--current-background)', color: 'var(--current-text)', transition: 'background-color 0.5s ease, color 0.5s ease' }} className='text-area p-2'>
                </textarea>}
                {props.showInformation && <div className='information-text'>{props.fonts[props.typefaceSwiperIndex].information}</div>}
                <div onClick={switchFontSize} className={`navigation right-navigation ${props.additionalClasses}`} onMouseMove={props.onMouseMove}
                    onMouseLeave={props.onMouseLeave} id='fontSizeSwiper'>
                    <div className='navigation-titles'>
                        <div>
                            Size
                        </div>
                    </div>
                    <div className='swiper-container'>
                        <Swiper
                            className='swiper'
                            allowTouchMove={true}
                            onSwiper={setSwipers}
                            slidesPerView={'auto'}
                            style={{ height: '100%' }}
                            direction='vertical'
                            autoHeight={true}
                            centeredSlides={true}
                            initialSlide={swipersIndex}
                            onSlideChangeTransitionStart={(swipers) => {
                                setSwipersIndex(swipers.activeIndex);
                            }}
                        >
                            {sizes.map((folderName, index) => (
                                <SwiperSlide className='swiper-slide-s' key={index}>
                                    <div className={`number-swiper-item ${swipersIndex === index ? 'active' : ''}`}>
                                        {folderName}
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
            )
            }
        </React.Fragment>
    );
}

export default Typefaces;